// Allowed categories used their own categories. Unallowed categories use all.
export var allowedReviewCategories = {
    "basic-tshirt": true,
    "design-tshirt": true,
    "polo-shirt": true,
    "basic-shirt": true,
    "sweater": true,
    // "other-atasan" : true,
};
